(function ($) {
    'use strict';

    $.fn.mainpageSlider = function (options) {
        var slider = new MainpageSlider(this, options);


        var width = $(window).width(),
            height = $(window).height();

        $(window).resize(function () {
            slider.imageMarginLeft = 0;

            //on mobile devices resize is triggered on mouse scroll, so need to prevent call to this method
            if ($(window).width() != width && $(window).height() != height) {
                slider.setSliderDimensions();
            }
        });

        return this;
    };

    function MainpageSlider(selector, options) {
        this.$selector = $(selector);
        this.$pager = $('.slider-pager');
        this.imageHeigthRatio = 0;
        this.interval = null;
        this.fadeSpeed = 800;
        this.currentItemIndex = 0;
        this.imageResizedWidthRatio = 0;
        this.imageMarginLeft = 0;
        this.easing = options.easing || this.constructor.defaults.easing;
        this.duration = options.duration || this.constructor.defaults.duration;
        this.pagerPosition = options.pagerPosition || this.constructor.defaults.pagerPosition;
        this.captionType = options.captionType || this.constructor.defaults.captionType;
        this.currentCaptionDuration = options.captionDuration || this.constructor.defaults.captionDuration;
        this.currentCaptionTopOffset = options.captionTopOffset || this.constructor.defaults.captionTopOffset;
        this.fitToScreen = options.fitToScreen || this.constructor.defaults.fitToScreen;
        this.subtractHeightFunc = options.subtractHeightFunc || this.constructor.defaults.subtractHeightFunc;
        this.init();

        //options
        this.options = $.extend({}, this.constructor.defaults);
        this.mergeOptions(options);

        //set transition value. Default is fade
        this.currentTransition = options.transition || this.options.transition.fade;
        this.$selector.addClass(this.currentTransition);
    }

    MainpageSlider.defaults = {
        easing: 'linear',
        transition: {
            fade: 'fade',
            slideDown: 'slideDown'
        },
        duration: 4000,
        captionType: {
            simple: 'simple',
            custom: 'custom'
        },
        captionEasing: 'linear',
        captionDuration: 1000,
        captionTopOffset: '10%',
        pagerPosition: {
            right: 'right',
            cener: 'center'
        },
        fitToScreen: {
            yes: "yes",
            no: "no"
        },
        subtractHeightFunc: function () { }
    };

    MainpageSlider.prototype.mergeOptions = function (options) {
        $.extend(this.options, options);
    };

    MainpageSlider.prototype.init = function () {
        var self = this;

        if (self.currentTransition === self.constructor.defaults.transition.fade) {
            self.$selector.find('li').not(':first').css('display', 'none');
        }
        self.$selector.find(':first').addClass('current');
        self.$pager.addClass(self.pagerPosition);
        self.$pager.find(':first').children('a').addClass('active');
        if (self.captionType === self.constructor.defaults.captionType.simple) {
            self.$selector.find('li:first').find('.caption').css({ top: '30%' });
        }

        self.start();
        self.setSliderDimensions();
        self.bindEvents();

        return false;
    };

    MainpageSlider.prototype.start = function () {
        var self = this;

        self.interval = setInterval(function () {
            if (self.$selector.find('li').length > 1) {
                self.moveNext();
            }
        }, self.duration);

        return false;
    };

    MainpageSlider.prototype.setSliderDimensions = function () {
        var self = this;

        var image = new Image();
        image.onload = function () {
            //if we need to fit slider into screen, and calculation function is provided then
            if (self.fitToScreen === self.constructor.defaults.fitToScreen.yes
                && typeof self.subtractHeightFunc === 'function') {

                var imgRatio = this.width / this.height;
                var imageTargetHeight,
                    imageTargetWidth,
                    imageWrapperHeight,
                    imageWidthRatio,
                    imageMarginTop = 0,
                    windowWidth = $('.slider-outer').width() || $(window).width(),
                    windowHeight = $(window).height();

                //set targeted height for image and wrapper
                imageTargetHeight = imageWrapperHeight = windowHeight - self.subtractHeightFunc();
                //calculate width proportionally
                self.imageHeigthRatio = this.height / imageTargetHeight;
                imageTargetWidth = this.width / self.imageHeigthRatio;


                if (imageTargetWidth < windowWidth) {
                    //recalculate image height and width
                    imageWidthRatio = windowWidth / imageTargetWidth;
                    imageTargetWidth = windowWidth;
                    imageTargetHeight = imageTargetHeight * imageWidthRatio;

                    //calculate margin-top for optimum image view
                    if (imageTargetHeight > imageWrapperHeight) {
                        imageMarginTop = (imageTargetHeight - imageWrapperHeight) / 2;
                    }
                } else {
                    //calculate margin-left for optimum image view
                    self.imageMarginLeft = (imageTargetWidth - windowWidth) / 2;
                }

                self.imageResizedWidthRatio = this.width / windowWidth;

                self.$selector.find('.slider-image').parent().css({
                    'overflow': 'hidden',
                    'position': 'relative',
                    'width': '100%',
                    'height': '100%'
                });
                self.$selector.find('.slider-item').css({
                    'height': imageWrapperHeight + 'px',
                    'width': imageTargetWidth + 'px'
                });
                self.$selector.css({
                    'height': imageWrapperHeight + 'px',
                    'top': -self.$selector.find('.current').index() * imageWrapperHeight + 'px'
                });

                self.$selector.find('.slider-image').css({
                    'height': imageTargetHeight + 'px',
                    'width': imageTargetWidth + 'px',
                    'marginTop': -imageMarginTop + 'px',
                    'marginLeft': -self.imageMarginLeft + 'px'
                });
            }
            else {
                if ($(window).width() < this.width) {
                    imageWidthRatio = $(window).width() / this.width;
                    self.$selector.css({
                        'height': (this.height * imageWidthRatio) + 'px'
                    });
                } else {
                    self.$selector.css({
                        'height': this.height + 'px'
                    });
                }
            }
            self.setCaptionForCurrent();
        };

        image.src = self.$selector.find('li:first .slider-image').attr('src');

        return false;
    };

    MainpageSlider.prototype.moveToFirst = function () {
        var self = this;
        self.$selector.find('li.current').removeClass('current');
        var $current = self.$selector.find('li:first').addClass('current');

        if (self.currentTransition === self.constructor.defaults.transition.fade) {
            $current.show(0)
                .parent()
                .find('li')
                .not('.current')
                .fadeOut(self.fadeSpeed);
        }
        else if (self.currentTransition === self.constructor.defaults.transition.slideDown) {
            self.$selector.animate({
                top: "0px",
            }, {
                duration: self.fadeSpeed,
                easing: self.easing,
                complete: function () {
                    self.setCaptionForCurrent();
                }
            });
        }
        return false;
    };

    MainpageSlider.prototype.moveToLast = function () {
        var self = this;
        self.$selector.find('li.current').removeClass('current');
        var $current = self.$selector.find('li:last').addClass('current');

        if (self.currentTransition === self.constructor.defaults.transition.fade) {
            $current.show(0)
                .parent()
                .find('li')
                .not('.current')
                .fadeOut(self.fadeSpeed);
        }
        else if (self.currentTransition === self.constructor.defaults.transition.slideDown) {
            //TODO: Write implementation
            //self.$selector.animate({
            //    top: "-= 0px",
            //}, {
            //    easing: "swing",
            //    duration: self.fadeSpeed
            //});
        }
        return false;
    };

    MainpageSlider.prototype.setPagerPosition = function () {
        var self = this;

        if (self.$pager.find('.active').parent().next().length > 0) {
            self.$pager.find('.active')
                .removeClass('active')
                .parent()
                .next()
                .children()
                .addClass('active');
        }
        else {
            self.$pager.find('div:last').children('a').removeClass('active');
            self.$pager.find('div:first')
                .children('a')
                .addClass('active');
        }
        return false;
    };

    MainpageSlider.prototype.cubicBezier = function (easing) {
        var cubicBezier = 'ease';
        switch (easing) {
            case 'easeOutCubic':
                cubicBezier = 'cubic-bezier(.215, .61, .355, 1)';
                break;
            case 'easeInOutCubic':
                cubicBezier = 'cubic-bezier(.645,.045,.355,1)';
                break;
            case 'easeInCirc':
                cubicBezier = 'cubic-bezier(.6,.04,.98,.335)';
                break;
            case 'easeOutCirc':
                cubicBezier = 'cubic-bezier(.075,.82,.165,1)';
                break;
            case 'easeInOutCirc':
                cubicBezier = 'cubic-bezier(.785,.135,.15,.86)';
                break;
            case 'easeInExpo':
                cubicBezier = 'cubic-bezier(.95,.05,.795,.035)';
                break;
            case 'easeOutExpo':
                cubicBezier = 'cubic-bezier(.19,1,.22,1)';
                break;
            case 'easeInOutExpo':
                cubicBezier = 'cubic-bezier(1,0,0,1)';
                break;
            case 'easeInQuad':
                cubicBezier = 'cubic-bezier(.55,.085,.68,.53)';
                break;
            case 'easeOutQuad':
                cubicBezier = 'cubic-bezier(.25,.46,.45,.94)';
                break;
            case 'easeInOutQuad':
                cubicBezier = 'cubic-bezier(.455,.03,.515,.955)';
                break;
            case 'easeInQuart':
                cubicBezier = 'cubic-bezier(.895,.03,.685,.22)';
                break;
            case 'easeOutQuart':
                cubicBezier = 'cubic-bezier(.165,.84,.44,1)';
                break;
            case 'easeInOutQuart':
                cubicBezier = 'cubic-bezier(.77,0,.175,1)';
                break;
            case 'easeInQuint':
                cubicBezier = 'cubic-bezier(.755,.05,.855,.06)';
                break;
            case 'easeOutQuint':
                cubicBezier = 'cubic-bezier(.23,1,.32,1)';
                break;
            case 'easeInOutQuint':
                cubicBezier = 'cubic-bezier(.86,0,.07,1)';
                break;
            case 'easeInSine':
                cubicBezier = 'cubic-bezier(.47,0,.745,.715)';
                break;
            case 'easeOutSine':
                cubicBezier = 'cubic-bezier(.39,.575,.565,1)';
                break;
            case 'easeInOutSine':
                cubicBezier = 'cubic-bezier(.445,.05,.55,.95)';
                break;
            case 'easeInBack':
                cubicBezier = 'cubic-bezier(.6,-.28,.735,.045)';
                break;
            case 'easeOutBack':
                cubicBezier = 'cubic-bezier(.175, .885,.32,1.275)';
                break;
            case 'easeInOutBack':
                cubicBezier = 'cubic-bezier(.68,-.55,.265,1.55)';
                break;
        }
        return cubicBezier;
    };

    MainpageSlider.prototype.animateCaption = function (element) {
        var self = this;

        var captionImage = new Image();
        captionImage.src = $(element).find('img').attr("src");

        captionImage.onload = function () {
            var translate3d;
            var movePercentage = $(element).attr('data-animate-percentage');
            var moveDirection = $(element).attr('data-move-to');
            var move = {}, marginTop = 0, marginLeft = 0, tx = 0, ty = 0;

            if (self.$selector.find('.current').find('.slider-image').css('marginTop')) {
                marginTop = parseInt(self.$selector.find('.current').find('.slider-image').css('marginTop').replace('px', ''));
            }
            if (self.$selector.find('.current').find('.slider-image').css('marginLeft')) {
                marginLeft = parseInt(self.$selector.find('.current').find('.slider-image').css('marginLeft').replace('px', ''));
            }

            switch (moveDirection) {
                case "left":
                    tx = self.$selector.find('.current').width()
                        - (self.$selector.find('.current').width() * (movePercentage / 100)
                        + ($(element).width() / 2)
                        - marginLeft);
                    ty = self.$selector.find('.current').height()
                          - (($(element).attr('data-y') / 100)
                          * self.$selector.find('.current').height()
                          - ($(element).height() / 2)
                          + marginTop);

                    translate3d = 'translate3d(' + tx + 'px,-' + ty + 'px' + ',0)';
                    break;
                case "right":
                    tx = self.$selector.find('.current').width() * (movePercentage / 100)
                      - ($(element).width() / 2)
                      + marginLeft;
                    ty = self.$selector.find('.current').height()
                          - (($(element).attr('data-y') / 100)
                          * self.$selector.find('.current').height()
                          - ($(element).height() / 2)
                          + marginTop);

                    translate3d = 'translate3d(' + tx + 'px,-' + ty + 'px' + ',0)';
                    break;
                case "top":
                    tx = (($(element).attr('data-x') / 100) * self.$selector.find('.current').width())
                       - ($(element).width() / 2)
                       + marginLeft;
                    ty = self.$selector.find('.current').height() * (movePercentage / 100)
                        + ($(element).height() / 2)
                        - marginTop;

                    translate3d = 'translate3d(' + tx + 'px,' + '-' + ty + 'px' + ',0)';
                    break;
                case "bottom":
                    tx = (($(element).attr('data-x') / 100) * self.$selector.find('.current').width())
                        - ($(element).width() / 2)
                        + marginLeft;
                    ty = self.$selector.find('.current').height() * (movePercentage / 100)
                        + ($(element).height() / 2)
                        - marginTop;

                    translate3d = 'translate3d(' + tx + 'px,' + '-' + ty + 'px' + ',0)';
                    break;
            }

            move['transform'] = translate3d;
            move['msTransform'] = translate3d;
            move['webkitTransform'] = translate3d;

            move['transition'] = 'all ' + $(element).attr('data-easing-speed') + 'ms ' + self.cubicBezier($(element).attr('data-easing'));
            move['transition-delay'] = $(element).attr('data-easing-delay') + 'ms';

            $(element).css(move);
        }
        return false;
    };

    MainpageSlider.prototype.setCaptionStartPosition = function (el) {
        var self = this;

        var captionImageHeight = 1;
        var captionImageWidth = 1;

        if ($(el).find('img').length > 0) {

            var captionImage = new Image();
            captionImage.src = $(el).find('img').attr("src");
            captionImage.onload = function () {

                //Resize the caption image proportionally to the slided item 
                captionImageHeight = this.height / self.imageResizedWidthRatio;
                captionImageWidth = this.width / self.imageResizedWidthRatio;

                //Recalculate caption dimensions for slider margin left value
                if (self.imageMarginLeft > 0) {
                    captionImageWidth = captionImageWidth + (captionImageWidth * (self.imageMarginLeft / $(window).width()));
                }
                $(el).find('img').css({
                    'width': captionImageWidth + 'px'
                });

                var transform = {}, translate3d, tx = 0, ty = 0, marginLeft = 0, marginTop = 0;
                if (self.$selector.find('.current').find('.slider-image').css('marginTop')) {
                    marginTop = parseInt(self.$selector.find('.current').find('.slider-image').css('marginTop').replace('px', ''));
                }
                if (self.$selector.find('.current').find('.slider-image').css('marginLeft')) {
                    marginLeft = parseInt(self.$selector.find('.current').find('.slider-image').css('marginLeft').replace('px', ''));
                }

                switch ($(el).attr('data-start-position')) {
                    case 'top':
                        tx = ($(el).attr('data-x') / 100)
                            * self.$selector.find('.current').width()
                            - (captionImageWidth / 2)
                            + marginLeft;
                        ty = self.$selector.find('.current').find('.slider-image').height()
                            + ($(el).height());

                        translate3d = 'translate3d(' + tx + 'px,-' + ty + 'px,' + '0px)'
                        break;
                    case 'bottom':
                        tx = ($(el).attr('data-x') / 100)
                           * self.$selector.find('.current').width()
                           - (captionImageWidth / 2)
                           + marginLeft;
                        ty = self.$selector.find('.current').find('.slider-image').height()
                            + ($(el).height());

                        translate3d = 'translate3d(' + tx + 'px,' + ty + 'px,' + '0px)'
                        break;
                    case 'right':
                        tx = self.$selector.find('.current').width()
                            + $(el).width()
                            - marginLeft;
                        ty = self.$selector.find('.current').height()
                          - (($(el).attr('data-y') / 100)
                          * self.$selector.find('.current').height()
                          - ($(el).height() / 2)
                          + marginTop);

                        translate3d = 'translate3d(' + tx + 'px,-' + ty + 'px,' + '0px)'
                        break;
                    case 'left':
                        tx = $(el).width();
                        ty = self.$selector.find('.current').height()
                          - (($(el).attr('data-y') / 100)
                          * self.$selector.find('.current').height()
                          - ($(el).height() / 2)
                          + marginTop);

                        translate3d = 'translate3d(-' + tx + 'px,-' + ty + 'px,' + '0px)'
                        break;
                }

                transform['transform'] = translate3d;
                transform['msTransform'] = translate3d;
                transform['webkitTransform'] = translate3d;
                $(el).css(transform);
            };
        }
        return false;
    };

    MainpageSlider.prototype.setCaptionForCurrent = function () {
        var self = this;

        if (self.captionType === self.constructor.defaults.captionType.custom) {

            self.$selector.find('.current').find('.caption').each(function (indx, el) {

                self.setCaptionStartPosition(el);

                if (!$(el).hasClass('animated')) {
                    self.animateCaption(el);
                    $(el).css({ opacity: 1 }).addClass('animated');
                }
            });

        } else if (self.captionType === self.constructor.defaults.captionType.simple) {

            var $current = self.$selector.find('.current').find('.caption');
            if (!$current.hasClass('animated')) {
                $current.animate({
                    top: '+=' + self.currentCaptionTopOffset,
                    opacity: 1
                }, {
                    duration: self.currentCaptionDuration
                }).addClass('animated');
            }
        }

        self.resetCaptionForNonCurrents();
    };

    MainpageSlider.prototype.resetCaptionForNonCurrents = function () {
        var self = this;

        if (self.captionType === self.constructor.defaults.captionType.custom) {

            self.$selector.find('li').not('.current').find('.caption').each(function (indx, el) {

                self.setCaptionStartPosition(el);

                $(el).css({
                    opacity: 0,
                    transform: 'translate3d(0,0,0)'
                }).removeClass('animated');

            });

        } else if (self.captionType === self.constructor.defaults.captionType.simple) {

            self.$selector.find('li').not('.current').find('.caption').animate({
                top: '30%',
                opacity: 0
            }, {
                duration: self.currentCaptionDuration
            }).removeClass('animated');
        }
    };

    MainpageSlider.prototype.moveNext = function () {
        var self = this;

        if (self.$selector.find('.current').next('li').length) {
            if (self.currentTransition === self.constructor.defaults.transition.fade) {

                self.$selector.find('.current')
                    .fadeOut(self.fadeSpeed)
                    .removeClass('current')
                    .next('li').addClass('current')
                    .fadeIn(self.fadeSpeed)
                    .parent().find('li').not('.current')
                    .fadeOut(self.fadeSpeed);
            }
            else if (self.currentTransition === self.constructor.defaults.transition.slideDown) {
                self.$selector.find('.current')
                    .removeClass('current')
                    .next('li')
                    .addClass('current');

                self.$selector.animate({
                    top: "-=" + self.$selector.height() + 'px',
                }, {
                    duration: self.fadeSpeed,
                    easing: self.easing,
                    complete: function () {
                        self.setCaptionForCurrent();
                    }
                });
            }
        }
        else {
            self.moveToFirst();
        }

        self.setPagerPosition();
        return false;
    };

    MainpageSlider.prototype.movePrev = function () {
        var self = this;

        self.$selector.find('.current').fadeOut(self.fadeSpeed);

        if (self.$selector.find('.current').prev('li').length) {
            if (self.currentTransition === self.constructor.defaults.transition.fade) {
                self.$selector.find('.current')
                    .removeClass('current')
                    .prev('li')
                    .addClass('current')
                    .fadeIn(self.fadeSpeed);
            }
            else if (self.currentTransition === self.constructor.defaults.transition.slideDown) {
                //TODO:write implementation
            }
        }
        else {
            self.moveToLast();
        }
        self.setPagerPosition();
        return false;
    };

    MainpageSlider.prototype.bindEvents = function () {
        var self = this;

        $('.right-arrow').on('click', function (e) {
            e.stopPropagation();
            self.moveNext();
            return false;
        });

        $('.left-arrow').on('click', function (e) {
            e.stopPropagation();
            self.movePrev();
            return false;
        });

        $(self.$pager.children('.pager-item')).on('click', function (e) {

            if ($(this).children('a').hasClass('active')) {
                return;
            }

            clearInterval(self.interval);
            var index = $(this).index();

            self.$pager.find('.active').removeClass('active');
            self.$pager.find('a:eq(' + index + ')').addClass('active');

            if (self.currentTransition === self.constructor.defaults.transition.fade) {
                self.$selector.find('.current')
                    .fadeOut(self.fadeSpeed)
                    .removeClass('current')
                    .parent().children(':eq(' + index + ')').addClass('current')
                    .fadeIn(self.fadeSpeed)
                    .parent().find('li').not('.current')
                    .fadeOut(self.fadeSpeed);
            }
            else if (self.currentTransition === self.constructor.defaults.transition.slideDown) {
                self.$selector.find('.current')
                    .removeClass('current')
                    .parent()
                    .children(':eq(' + index + ')')
                    .addClass('current');

                self.$selector.animate({
                    top: "-" + (self.$selector.height() * index) + 'px',
                }, {
                    duration: self.fadeSpeed,
                    easing: self.easing,
                    complete: function () {
                        self.setCaptionForCurrent();
                    }
                });
            }

            self.interval = setInterval(function () {
                self.moveNext();
            }, self.duration);

            return false;
        });
    };
})(jQuery);